import { Badge } from "@/components/ui/badge";

export type RangePreset = "24h" | "7d" | "30d" | "custom";
export type StatusFilter = "all" | "sent" | "failed" | "suppressed" | "pending";

export type LogRow = {
  id: string;
  message_id: string | null;
  template_name: string | null;
  recipient_email: string | null;
  status: string | null;
  error_message: string | null;
  metadata: unknown;
  created_at: string;
};

export type Counts = {
  total: number;
  sent: number;
  failed: number;
  suppressed: number;
  pending: number;
  other: number;
};

export const PAGE_SIZE = 50;

export function statusBadge(status: string | null) {
  const s = status ?? "unknown";
  if (s === "sent") {
    return <Badge className="bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30">Sent</Badge>;
  }
  if (["dlq", "failed", "bounced", "complained"].includes(s)) {
    return <Badge variant="destructive">{s === "dlq" ? "Failed" : s}</Badge>;
  }
  if (s === "suppressed") {
    return <Badge className="bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/30">Suppressed</Badge>;
  }
  if (s === "pending") {
    return <Badge variant="secondary">Pending</Badge>;
  }
  return <Badge variant="outline">{s}</Badge>;
}
